var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgManageAppointments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 57.228,
    height: 62.84,
    viewBox: "0 0 57.228 62.84",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12996",
    d: "M21.052 25.375h-6.919a1.063 1.063 0 0 0-1.063 1.063v6.919a1.063 1.063 0 0 0 1.063 1.063h6.919a1.063 1.063 0 0 0 1.063-1.063v-6.919a1.063 1.063 0 0 0-1.063-1.063zm-1.063 6.919H15.2V27.5h4.793z",
    transform: "translate(-5.082 .825)",
    style: {
      fill: "#d24350"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12997",
    d: "M34.665 25.375h-6.919a1.063 1.063 0 0 0-1.063 1.063v6.919a1.063 1.063 0 0 0 1.063 1.063h6.919a1.063 1.063 0 0 0 1.063-1.063v-6.919a1.064 1.064 0 0 0-1.063-1.063zM33.6 32.294h-4.791V27.5H33.6z",
    transform: "translate(-2.558 .825)",
    style: {
      fill: "#d24350"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12998",
    d: "M47.858 25.375h-6.919a1.063 1.063 0 0 0-1.063 1.063v6.919a1.063 1.063 0 0 0 1.063 1.063h6.919a1.063 1.063 0 0 0 1.063-1.063v-6.919a1.063 1.063 0 0 0-1.063-1.063zm-1.063 6.919H42V27.5h4.793z",
    transform: "translate(-.112 .825)",
    style: {
      fill: "#d24350"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 12999",
    d: "M21.052 38.67h-6.919a1.063 1.063 0 0 0-1.063 1.063v6.919a1.063 1.063 0 0 0 1.063 1.063h6.919a1.063 1.063 0 0 0 1.063-1.063v-6.919a1.063 1.063 0 0 0-1.063-1.063zm-1.063 6.919H15.2V40.8h4.793z",
    transform: "translate(-5.082 3.289)",
    style: {
      fill: "#d24350"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13000",
    d: "M34.665 38.67h-6.919a1.063 1.063 0 0 0-1.063 1.063v6.919a1.063 1.063 0 0 0 1.063 1.063h6.919a1.063 1.063 0 0 0 1.063-1.063v-6.919a1.063 1.063 0 0 0-1.063-1.063zM33.6 45.588h-4.791V40.8H33.6z",
    transform: "translate(-2.558 3.289)",
    style: {
      fill: "#d24350"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13001",
    d: "M47.858 38.67h-6.919a1.063 1.063 0 0 0-1.063 1.063v6.919a1.063 1.063 0 0 0 1.063 1.063h6.919a1.063 1.063 0 0 0 1.063-1.063v-6.919a1.063 1.063 0 0 0-1.063-1.063zm-1.063 6.919H42V40.8h4.793z",
    transform: "translate(-.112 3.289)",
    style: {
      fill: "#d24350"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 13002",
    d: "M62.5 8.886h-7.051V7.473a4.2 4.2 0 0 0-8.4 0v1.413h-7.912V7.473a4.2 4.2 0 0 0-8.4 0v1.413h-7.912V7.473a4.2 4.2 0 0 0-8.4 0v1.414H7.394a1.063 1.063 0 0 0-1.063 1.062v55.1a1.063 1.063 0 0 0 1.063 1.063H62.5a1.064 1.064 0 0 0 1.063-1.063v-55.1A1.063 1.063 0 0 0 62.5 8.886zM49.175 7.473a2.074 2.074 0 0 1 4.148 0v5.866a2.074 2.074 0 0 1-4.148 0zM34.937 5.4a2.076 2.076 0 0 1 2.074 2.074v5.866a2.074 2.074 0 1 1-4.147 0v-3.292c0-.033.01-.065.01-.1s-.007-.067-.01-.1V7.473A2.076 2.076 0 0 1 34.937 5.4zM16.551 7.473a2.074 2.074 0 1 1 4.147 0v5.866a2.074 2.074 0 1 1-4.147 0zm44.882 56.514H8.458V11.012h5.968v2.328a4.2 4.2 0 0 0 8.4 0v-2.327h7.912v2.327a4.2 4.2 0 0 0 8.4 0v-2.327h7.912v2.327a4.2 4.2 0 0 0 8.4 0v-2.33h5.984z",
    transform: "translate(-6.331 -3.273)",
    style: {
      fill: "#333"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgManageAppointments);
export default __webpack_public_path__ + "static/media/manage-appointments.5a1dd089f788215abe4548805a70af2b.svg";
export { ForwardRef as ReactComponent };